import { ArrayDetectorType, DeviceInformationDto } from '@/api/generator';

export function deviceInfoValueOf(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim();
  return !trimmed || trimmed === '-1' || trimmed === '0' ? undefined : trimmed;
}

export interface ConnectedArrayInfo {
  // TODO: a tNumber would be really helpful
  name: string;
  serialNumber?: string;
}

/**
 * The array a detector interface reports as connected. At most one, and only
 * as a type designation — not a registered QA-equipment entity. Every presence
 * message is a full snapshot: an absent/sentinel/NoArray arrayDetector means nothing
 * is connected.
 */
export function connectedArrayInfoOf(
  info: DeviceInformationDto | null | undefined,
): ConnectedArrayInfo | undefined {
  const name = deviceInfoValueOf(info?.arrayDetector);
  if (!name || name === ArrayDetectorType.NoArray) {
    return undefined;
  }
  return {
    name,
    // The backend dropped arrayDetectorSerialNumber from DeviceInformationDto;
    // restore once it is reported again.
    // serialNumber: deviceInfoValueOf(info?.arrayDetectorSerialNumber),
  };
}
